// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"bfb724ba","121":"c577f0fa","126":"b5564c88","129":"b677134f","163":"546e0f7b","251":"1a4ffae7","391":"60e3a765","420":"ea4769f5","571":"e8320032","606":"2e492336","693":"471b554a","767":"68e55747","916":"8cd08e21"}[chunkId] + ".chunk.js";
};